import React, { useState, useEffect } from "react";
import { IComponentImage } from "../../component";
import { formatImage, isIphoneX, getPageSameType } from "../../utils/util";
import { style } from "../../utils/image";
import ComponentLink from "../ComponentLink";
import classNames from "classnames";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import "./Image.scss";
import { createPortal } from "react-dom";
import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";

const beforeNode = window.document.createElement("div");
window.document.body.insertBefore(
  beforeNode,
  window.document.getElementById("root")
);

const ModalMap = (props: {
  modalMap: any;
  btn: any;
  setModalMap: (content: any) => void;
}) => {
  const { modalMap, setModalMap, btn } = props;
  return createPortal(
    <div
      className={
        "pendent-modal " + (modalMap[`${btn.link!.modalcontent}`] ? "show" : "")
      }
    >
      <div className="wrapper">
        <img src={style(btn.link!.modalcontent, "wx_560_n")} />
      </div>
      <div
        className="close"
        onClick={() => {
          let newModalMap = {
            ...modalMap,
            [String(btn.link!.modalcontent)]: false,
          };
          clearAllBodyScrollLocks();
          setModalMap(newModalMap);
        }}
      >
        <img src={require("../../assets/x-white.png")} />
      </div>
    </div>,
    document.body
  );
};

const Image = function (props: IComponentImage) {
  const { mode, images, cid, container } = props;
  const len = +mode;
  const imageLength = (images || []).length;

  // 只渲染mode个，不足mode个的话显示mode个
  const cls = classNames("one-image", `column-${mode}`);

  const [modalMap, setModalMap] = useState({} as any);

  const onClick = (one: any) => {
    let { link } = one;
    if (link && link.type && link.type == "modal-image") {
      let newModalMap = {
        ...modalMap,
        [String(link.modalcontent)]: true,
      };
      setModalMap(newModalMap);
      // disableBodyScroll(document.body);
    } else {
      link && ComponentLink.to(link);
    }
  };

  const modalButtons = (images || []).filter((btn, index) => {
    return btn && btn.link && btn.link.type == "modal-image";
  });

  const [fixed, setFixed] = useState(false);
  useEffect(() => {
    const timer = setInterval(() => {
      let image = document.getElementById(`image_bottom_${cid}`);

      if (image) {
        var offset = image.offsetTop;
        var height = window.innerHeight;

        if (offset + image.offsetHeight < height) {
          if (!fixed) {
            image.style.height = image.offsetHeight + "px";
            setFixed(true);
          }
        } else {
          if (fixed) {
            setFixed(false);
          }
        }
      }
    }, 160);

    return () => {
      clearInterval(timer);
    };
  }, [fixed]);

  const renderMethod = fixed
    ? createPortal
    : (reactNode: any, params?: any) => reactNode;

  const [realBottom, setRealBottom] = useState(0);
  useEffect(() => {
    let { template } = window.pageDetail;
    let paddingBottom = 0;
    paddingBottom += isIphoneX() ? 22 : 0;
    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      paddingBottom += 49;
    }
    let imageHeight = 0;
    let image = document.getElementById(`image_bottom_${cid}`);
    if (image) {
      imageHeight = Math.max(imageHeight, image.offsetHeight);
    }
    setRealBottom(
      paddingBottom +
        imageHeight +
        (container && container.bottom ? Number(container.bottom) : 0)
    );
  }, []);

  return (
    <div id={`image_bottom_${cid}`}>
      {imageLength ? (
        renderMethod(
          <div
            className="component-image-wrapper"
            style={
              fixed
                ? {
                    position: "fixed",
                    bottom: `${realBottom}px`,
                    margin: container
                      ? `0 ${Math.max(
                          0,
                          Number(container.right)
                        )}px 0 ${Math.max(0, Number(container.left))}px`
                      : `auto`,
                  }
                : {}
            }
          >
            {Array(len)
              .fill("")
              .map((value, index) => {
                if (index < imageLength) {
                  const one = images[index];
                  // 有图片的
                  return (
                    <img
                      key={index}
                      className={cls}
                      // 修复一个undefined的图片加载
                      src={one.image ? formatImage(one.image) : ""}
                      alt=""
                      onClick={() => onClick(one)}
                    />
                  );
                } else {
                  // return <div key={index} className={cls} />;
                }
              })}

            {modalButtons && modalButtons.length ? (
              <>
                {modalButtons.map((btn, index) => {
                  return (
                    <ModalMap
                      key={index}
                      btn={btn}
                      modalMap={modalMap}
                      setModalMap={setModalMap}
                    />
                  );
                })}
              </>
            ) : null}
          </div>,
          beforeNode
        )
      ) : (
        <div />
      )}
    </div>
  );
};

export default Image;
